import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Chapter } from '../models/chapter';
import { deleteChapterEndpoint } from './const';

export const deleteChapter = (chapter: Chapter) => {
    chapter.isDeleted = true;
    return getHttpClient().post({ url: deleteChapterEndpoint, data: JSON.stringify(chapter) });
};
